import { ShellLink } from "@/src/components";

import log from "logbeacon";
import { NextImage } from "../NextImage";

export const ArrayRenderer = (props: any) => {
  const { children } = props;

  try {
    let data = [];
    if (Array.isArray(children)) {
      data = children;
    } else {
      try {
        data = JSON.parse(children);
      } catch (error) {
        data = children;
      }
    }

    if (!Array.isArray(data)) {
      throw new Error("Data is not an array");
    }
    return (
      <span className="w-full">
        {data.map((item, index) => {
          if (item?.url) {
            const url = new URL(item.url);
            const protocol = url.protocol; // 协议部分（包含冒号，例如 "https:"）
            const domain = url.hostname; // 域名部分（例如 "www.china.web3research.io"）
            const iconUrl = domain ? `${protocol}//${domain}/favicon.ico` : "";
            return (
              <ShellLink
                aria-label="Array Renderer"
                data-openreplay-label={`Array Renderer Link | ${item?.url}`}
                id="lnk-array-renderer"
                href={item?.url}
                key={index}
                target="_blank"
                className="flex flex-col gap-2 md:flex-row"
              >
                <span className="flex gap-2">
                  <NextImage
                    src={iconUrl}
                    alt={item.content}
                    placeholderSrc="/assets/images/globe_web_icon.png"
                    className="w-4 h-4 mt-[2px] min-w-4"
                  />
                  <span className="body_m max-w-[300px] text-content_secondary md:max-w-[420px] truncate">
                    {item.content}
                  </span>
                </span>
                <span className="text-content_quaternary body_m">{domain}</span>
              </ShellLink>
            );
          } else {
            return (
              <span className="flex gap-2" key={index}>
                <span className="body_m text-content_secondary break-words">
                  {item.content}
                </span>
              </span>
            );
          }
        })}
      </span>
    );
  } catch (error) {
    log.debug("[文案]error", error);
    return <span>{children}</span>;
  }
};
